import React, { useEffect, useState } from 'react';
import css from './SectionPrizesOfMonth.css';
import { useRequest } from '../../../../hooks/useRequest';
import { getUserCountry } from '../../../../util/location';
import { getFlipAndWinMonthPrizes } from '../../../../util/api';
import { Alert, IconSpinner, SecondaryButton } from '../../../../components';
import { Slide } from 'pure-react-carousel';
import PrizeItem from './PrizeItem';
import Carousel from '../../../../components/ListingCardsCarousel/Carousel';
import routeConfiguration from '../../../../routeConfiguration';
import { createResourceLocatorString } from '../../../../util/routes';

export default ({ isMobile, history }) => {
    const [cards, setCards] = useState([]);
    const { error, loading, request } = useRequest();

    const navigateToFlipAndWin = () =>
        history.push(createResourceLocatorString('FlipAndWin', routeConfiguration()));

    const userCountry = getUserCountry();

    const requestCards = async () =>
        await request(
            () => getFlipAndWinMonthPrizes(userCountry),
            data => (Array.isArray(data) ? setCards(data) : null)
        );

    useEffect(() => {
        requestCards();
    }, []);

    if (loading) {
        return <IconSpinner />;
    }

    if (error) {
        return <Alert showAsPlainText type="failure" description={error} closeAllowed={false} />;
    }

    const monthPrizes = cards
        .filter(card => card.monthPrize)
        .map(card => ({
            ...card,
            id: card._id,
            description: card.dialogText1,
            inStock: (card.inStock || 0) - (card.totalWins || 0),
            total: card.inStock,
        }));

    const showPrizesBlock = monthPrizes.length > 0;
    const showAsSlider = isMobile ? monthPrizes.length > 1 : monthPrizes.length > 2;

    return showPrizesBlock ? (
        <section className={css.root}>
            <div className={css.content}>
                <h2 className={css.heading}>Gewinne des Monats</h2>
                <p>Gewinne täglich Preise deiner Lieblingsmarken.</p>
            </div>
            <div className={css.carouselHolder}>
                {showAsSlider ? (
                    <Carousel
                        isMobile={isMobile}
                        items={monthPrizes}
                        sliderClassName={css.slider}
                        sliderVisibleSlides={isMobile ? 1 : 2}
                        hideButtonsOnEndStart
                        rendererCarousel={(item, index) => (
                            <Slide index={index} key={index}>
                                <PrizeItem {...item} onCardClick={() => navigateToFlipAndWin()} />
                            </Slide>
                        )}
                    />
                ) : (
                    <div className={css.prizesHolder}>
                        {monthPrizes.map(({ id, ...rest }, index) => (
                            <PrizeItem
                                key={id || index}
                                onCardClick={() => navigateToFlipAndWin()}
                                {...rest}
                            />
                        ))}
                    </div>
                )}
            </div>
            <SecondaryButton className={css.pageLink} onClick={() => navigateToFlipAndWin()}>
                Spiele Flip & Win
            </SecondaryButton>
        </section>
    ) : null;
};
